import { useRef, useState } from "react";
import { showToast } from "../../../utils";

interface UploadAndDisplayImageProps {
    images: Array<any>;
    onChange: (data: any) => void;
    onRemove: (idx: any, id?: any) => void;
    size?: any;
    style?: any
}

const CatalogueV2 = (props: UploadAndDisplayImageProps) => {

    const fileInputRef = useRef<HTMLInputElement>(null);
    const [dragging, setDragging] = useState(false);

    const fileSize = props?.size || 10
    const extensions = [".jpg", ".jpeg", ".png", ".JPG", ".JPEG", ".PNG"];

    const handleFiles = (file: any) => {
        var imgCount = 0, propsImgCount = 0, videoCount = 0, propsVideoCount = 0;
        if (props?.images?.length > 0) {
            props?.images?.map((item: any, idx: number) => (
                extensions.some(extension => item?.image?.includes(extension)) ? propsImgCount++ : propsVideoCount++))
        }
        for (var j = 0; j < file.length; j++) {
            if ((file[j].type.split('/')[0]) === 'image') {
                imgCount++;
            }
            else if ((file[j].type.split('/')[0]) === 'video') {
                videoCount++;
            }
        }
        if (imgCount + propsImgCount > 50) {
            showToast('Max allowed photos are 50', 'error');
            return
        }
        else if (videoCount + propsVideoCount > 10) {
            showToast('Max allowed video are 10', 'error');
            return
        }

        const data: any = []
        var acceptType = ["jpg", "jpeg", "png", "JPG", "JPEG", "PNG", "gif", "GIF", "mp4", "m4v", "mpg", "x-aiff", "video", "video/mp4", "video/x-msvideo"];
        for (var i = 0; i < file.length; i++) {
            if (acceptType.indexOf(file[i].type.split('/')[1]) !== -1) {
                if (((file[i].size / 1000) / 1000).toFixed(4) <= fileSize) {
                    const img = URL.createObjectURL(file[i])
                    data.push({ image: img, file: file[i] })
                }
                else {
                    //show error msg if file size in more than 10 mb
                    showToast('file size in more than 10 mb not supported', 'error')
                    document.getElementById("fileuplaod")!.innerHTML = "";
                }
            }
            else {
                //show error msg if file type is supported
                showToast('File type is not supported', 'error')
                document.getElementById("fileuplaod")!.innerHTML = "";
            }
        }
        props.onChange(data)
    }

    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setDragging(false);
        handleFiles(e.dataTransfer.files);
    };

    return (
        <div>
            <div
                className={`media-step__dropzone${dragging ? " media-step__dropzone--active" : ""}`}
                onClick={() => fileInputRef.current?.click()}
                onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
                onDragLeave={() => setDragging(false)}
                onDrop={handleDrop}
            >
                <input
                    ref={fileInputRef}
                    type="file"
                    // accept="image/jpg,image/jpeg,image/png"
                    accept="image/*,video/*"
                    multiple
                    hidden
                    onChange={(e) => handleFiles(e.target.files)}
                    id="fileuplaod"
                />
                <div className="media-step__dropzone-icon">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                        <rect x="2" y="8" width="36" height="26" rx="4" stroke="#a0aec0" strokeWidth="2" fill="none" />
                        <circle cx="14" cy="18" r="4" stroke="#a0aec0" strokeWidth="2" fill="none" />
                        <path d="M2 30l10-8 8 6 6-5 12 7" stroke="#a0aec0" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </div>
                <p className="media-step__dropzone-text">
                    <span className="media-step__dropzone-link">Click to upload</span>
                    {" "}or drag and drop
                </p>
                <p className="media-step__dropzone-hint">JPG, JPEG, PNG less than 1MB</p>
            </div>
            {/* Preview grid */}
            {props?.images?.length > 0 && (
                <div className="catalogue-previews">
                    {props.images.map((item, i) => (
                        <div
                            key={i}
                            className="catalogue-items"
                            style={{ position: "relative" }}
                        >
                            {item?.file?.type?.split("/")?.[0] === "image" ||
                                extensions.some(extension => item?.image?.includes(extension)) ? (
                                <img
                                    className="catalogue-preview-image"
                                    src={item?.image}
                                    alt={`Upload ${i + 1}`}
                                />
                            ) : (
                                <video
                                    className="catalogue-preview-video"
                                    src={item?.image}
                                    controls
                                />
                            )}

                            <img
                                className="catalogue-delete"
                                src="/assets/images/delete-btn-red.svg"
                                alt="Delete"
                                onClick={() => props.onRemove(i, item?.id)}
                            />
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

export default CatalogueV2;
